import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataEntity_Detail_04_Interface } from 'src/app/Interface/DataEntity/04/DataEntity_Detail_04_Interface';
import { DataEntity_Main_04_Interface } from 'src/app/Interface/DataEntity/04/DataEntity_Main_04_Interface';
import { DataEntity_Resolution_04_Interface } from 'src/app/Interface/DataEntity/04/DataEntity_Resolution_04_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DataEntity04Service {

  constructor(private http: HttpClient) { }


  GetSingle(Token: String,
    id: Number,
    dataentity_id: number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Dataentityno04/GetSingle?token=" + Token
      + "&id=" + id
      + "&dataentity_id=" + dataentity_id).pipe(
      map(data => {
        return data as any
      })
    )
  }

  Submit(
    model_temp: DataEntity_Main_04_Interface,
    detail: Array<DataEntity_Detail_04_Interface>,
    resolution: Array<DataEntity_Resolution_04_Interface>,
    DataEntity_id: number,
    Calibration_id: number,
    FolderName: string,
    DeviceSerial: string,
    DeviceCode: string,

    Manufacture_txt: String,
    Type_txt: String,
    Model_txt: String,
    LabAddress_txt: String,

    Token: String): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var file_list:Array<any>=[]

    for (let item of model_temp.filename) {
      file_list.push({
        id: 0,
        filename: item.title,
      })
    }

    var model={
      id:model_temp.id,
      manufacture: Manufacture_txt,
      model: Model_txt,
      pdf_src: FolderName,
      type: Type_txt,

      temperature_Air_before: model_temp.temperature_Air_before +'',
      temperature_Air_after: model_temp.temperature_Air_after+'',
      
      capability: model_temp.capability+'',

      humidity_Air_before: model_temp.humidity_Air_before+'',
      humidity_Air_after: model_temp.humidity_Air_after+'',

      pressure_before: model_temp.pressure_before+'',
      pressure_after: model_temp.pressure_after+'',

      range_nominal: model_temp.range_nominal+'',
      range_nominal_unit: model_temp.range_nominal_unit+'',
    }

    var body = {
      Calibration_id: Calibration_id,
      model: model,
      detail: detail,
      DeviceSerial: DeviceSerial,
      DeviceCode: DeviceCode,
      Token: Token,
      labAdderss: LabAddress_txt,
      dataentity_id: DataEntity_id,
      resolution : resolution,
      file :file_list,
    }

    return this.http.post(environment.BaseUrl + "Daro/Dataentityno04/Submit", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }

  uploadFile(body,Token:String){

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Dataentityno04/upload?token="+Token,body).pipe(
      map(data=>{
        return data
      })
    )
  }

  uploadPdf(body,Token:String){

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Dataentityno04/uploadPdf?token="+Token,body).pipe(
      map(data=>{
        return data
      })
    )
  }

}
